export const GetDaysString = (days: number) => {
  return days === 1 ? 'day' : 'days'
}
